var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAudiovideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "22px",
    viewBox: "0 0 24 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic/audiovideo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Version-12",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A03",
    transform: "translate(-408.000000, -312.000000)",
    fill: "#B4C3D0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B02"
  }, /*#__PURE__*/React.createElement("g", {
    id: "screen"
  }, /*#__PURE__*/React.createElement("g", {
    id: "settings-copy",
    transform: "translate(375.000000, 215.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tabs",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "audio-video",
    transform: "translate(0.000000, 78.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2371795,20.9061695 C33.8300598,20.9061695 33.5,20.5658163 33.5,20.146 C33.5,19.7261837 33.8300598,19.3858305 34.2371795,19.3858305 L38.0935128,19.3858305 C38.4205256,18.1040834 39.5537179,17.156 40.8978419,17.156 C42.2419658,17.156 43.3751581,18.1040834 43.7021709,19.3858305 L55.7628205,19.3858305 C56.1699402,19.3858305 56.5,19.7261837 56.5,20.146 C56.5,20.5658163 56.1699402,20.9061695 55.7628205,20.9061695 L43.7022692,20.9061695 C43.3752564,22.1879166 42.2420641,23.136 40.8979402,23.136 C39.5538162,23.136 38.4206239,22.1879166 38.0936111,20.9061695 L34.2371795,20.9061695 Z M55.7627254,27.7578305 C56.1698433,27.7578305 56.5,28.0981837 56.5,28.518 C56.5,28.9378163 56.1699416,29.2781695 55.7628237,29.2781695 L50.8492977,29.2781695 C50.5222862,30.5598153 49.3890988,31.508 48.0449806,31.508 C46.7008624,31.508 45.5676749,30.5598153 45.2406635,29.2781695 L34.2371763,29.2781695 C33.8300584,29.2781695 33.5,28.9378163 33.5,28.518 C33.5,28.0981837 33.8300584,27.7578305 34.2371763,27.7578305 L45.2405652,27.7578305 C45.5675766,26.4760834 46.7007641,25.528 48.0448823,25.528 C49.3890005,25.528 50.5221879,26.4760834 50.8491994,27.7578305 L55.7627254,27.7578305 Z M55.7628205,34.9338305 C56.1699402,34.9338305 56.5,35.2741837 56.5,35.694 C56.5,36.1138163 56.1699402,36.4541695 55.7628205,36.4541695 L43.7022692,36.4541695 C43.3752564,37.7359166 42.2420641,38.684 40.8979402,38.684 C39.5538162,38.684 38.4206239,37.7359166 38.0936111,36.4541695 L34.2371795,36.4541695 C33.8300598,36.4541695 33.5,36.1138163 33.5,35.694 C33.5,35.2741837 33.8300598,34.9338305 34.2371795,34.9338305 L38.0935128,34.9338305 C38.4205256,33.6521847 39.5537179,32.704 40.8978419,32.704 C42.2419658,32.704 43.3751581,33.6521847 43.7021709,34.9338305 L55.7628205,34.9338305 Z",
    id: "ic/audiovideo"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAudiovideo);
export default __webpack_public_path__ + "static/media/icon_audiovideo.3f55f979bbe5a35559bdae6b7329e5f9.svg";
export { ForwardRef as ReactComponent };